import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

export const SocialMediaSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().required(),
    partnerId: Yup.string().default(undefined),
    url: Yup.string().default(undefined),
    platform: Yup.string().default(undefined),
  });
